import {
  Autocomplete,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material'
import React from 'react'

const AddressField = ({
  label,
  field,
  companySettings,
  setCompanySettings,
  required,
}) => (
  <Grid item xs={12} lg={6}>
    <TextField
      label={label}
      fullWidth
      autoComplete="off"
      value={companySettings?.address?.[field] ?? ''}
      onChange={(e) =>
        setCompanySettings((prev) => ({
          ...prev,
          address: { ...prev.address, [field]: e.target.value },
        }))
      }
      required={required}
    />
  </Grid>
)

const Address = ({ companySettings, setCompanySettings }) => (
  <Grid item xs={12}>
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant="title3">Address</Typography>
      </Grid>
      <AddressField
        label="Line 1"
        field="line1"
        companySettings={companySettings}
        setCompanySettings={setCompanySettings}
        required
      />
      <AddressField
        label="Line 2"
        field="line2"
        companySettings={companySettings}
        setCompanySettings={setCompanySettings}
      />
      <AddressField
        label="Town"
        field="town"
        companySettings={companySettings}
        setCompanySettings={setCompanySettings}
      />
      <AddressField
        label="County"
        field="county"
        companySettings={companySettings}
        setCompanySettings={setCompanySettings}
        required
      />
      <AddressField
        label="Post Code"
        field="postCode"
        companySettings={companySettings}
        setCompanySettings={setCompanySettings}
        required
      />
      <Grid item xs={12} lg={6}>
        <FormControl fullWidth required>
          <InputLabel>Country</InputLabel>
          <Select
            value={companySettings?.address?.country ?? ''}
            onChange={(e) =>
              setCompanySettings((prev) => ({
                ...prev,
                address: { ...prev.address, country: e.target.value },
              }))
            }
            label="Country"
          >
            <MenuItem value="GB">United Kingdom</MenuItem>
            <MenuItem value="IE">Ireland</MenuItem>
            <MenuItem value="Other">Other</MenuItem>
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  </Grid>
)

export default Address
